import React from "react";
import '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBriefcase } from '@fortawesome/free-solid-svg-icons';
import { VerticalTimeline, VerticalTimelineElement } from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';
import '../assets/styles/Timeline.scss'

function Timeline() {
  return (
    <div id="history">
      <div className="items-container">
        <h1>Career History</h1>
        <VerticalTimeline>
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            contentStyle={{ background: 'white', color: 'rgb(39, 40, 34)' }}
            contentArrowStyle={{ borderRight: '7px solid  white' }}
            date="May 2025 - Aug 2025"
            iconStyle={{ background: '#5000ca', color: 'rgb(39, 40, 34)' }}
            icon={<FontAwesomeIcon icon={faBriefcase} />}
          >
            <h3 className="vertical-timeline-element-title">Cyber Intern</h3>
            <h4 className="vertical-timeline-element-subtitle">Washington DC</h4>
            <ul>
              <li>
                Engineered a streamlined SOP review automation system using Power BI, Power Automate, and Dataverse,
                reducing manual effort and saving hours of weekly work for 30+ employees
              </li>
              <li>
                Committed to ongoing professional development by studying CompTIA Security+ concepts through weekly
                cybersecurity training, strengthening foundational knowledge in secure systems and threat mitigation
              </li>
            </ul>

          </VerticalTimelineElement>
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            date="May 2024 - Sept 2024"
            iconStyle={{ background: '#5000ca', color: 'rgb(39, 40, 34)' }}
            icon={<FontAwesomeIcon icon={faBriefcase} />}
          >
            <h3 className="vertical-timeline-element-title">Software Engineer Intern</h3>
            <h4 className="vertical-timeline-element-subtitle">New York</h4>
            <ul>
              <li>
                Diagnosed and resolved semantic and edge case errors through deep code reviews, enhancing the stability and user
                experience of no-code development tools
              </li>
              <li>
                Implemented GraphQL queries, mutations, and fragments across bi-weekly sprints to enable and support new
                feature development from the product backlog
              </li>
              <li>
                Collaborated in sprint planning and led feature demos during bi-weekly reviews, improving stakeholder visibility
                into engineering progress and product development
              </li>
            </ul>
          </VerticalTimelineElement>
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            date="Jan 2023 - Present"
            iconStyle={{ background: '#5000ca', color: 'rgb(39, 40, 34)' }}
            icon={<FontAwesomeIcon icon={faBriefcase} />}
          >
            <h3 className="vertical-timeline-element-title">Software Engineering Teaching Assistant</h3>
            <h4 className="vertical-timeline-element-subtitle">Rochester Institute of Technology</h4>
            <ul>
              <li>
                Graded weekly programming assignments for 30 students, identifying semantic issues and debugging code to
                deliver detailed, personalized feedback, contributing to an average student grade above 90%
              </li>
              <li>
                Led weekly coding help sessions to support students with assignments, reinforcing key programming concepts and
                improving comprehension and performance
              </li>
            </ul>

          </VerticalTimelineElement>
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            date="Aug 2023 - Present"
            iconStyle={{ background: '#5000ca', color: 'rgb(39, 40, 34)' }}
            icon={<FontAwesomeIcon icon={faBriefcase} />}
          >
            <h3 className="vertical-timeline-element-title">Society of Software Engineers Mentor</h3>
            <h4 className="vertical-timeline-element-subtitle">Rochester Institute of Technology</h4>
            <ul>
              <li>
                Assisted students with software related assignments for 4hrs weekly, resulting in increased understanding of
                fundamental concepts
              </li>
              <li>
                Conducted resume reviews, interview prep and held coding challenges for 3hrs weekly which increased job
                application response rates and interview readiness
              </li>
            </ul>
          </VerticalTimelineElement>
        </VerticalTimeline>
      </div>
    </div>
  );
}

export default Timeline;